import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";

import "./Image.less";

const ImageComponent = ({ src, title, className = "", style = {} }) => {
  const classNames = ["image", className];
  return (
    <img
      src={src}
      alt={title}
      title={title}
      className={classNames.join(" ")}
      style={style}
    />
  );
};

ImageComponent.protoTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string)
};

const Image = ({ src, title, className = "", style = {} }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allFile(filter: { ext: { regex: "/(jpg|png|jpeg)/" } }) {
            edges {
              node {
                name
                publicURL
              }
            }
          }
        }
      `}
      render={result => {
        const image =
          result.allFile.edges.find(({ node }) => node.name === src).node ||
          null;
        if (image) {
          return (
            <ImageComponent
              src={image.publicURL}
              title={title}
              className={className}
              style={style}
            />
          );
        } else {
          return <span>Image not found</span>;
        }
      }}
    />
  );
};

Image.protoTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string)
};

export default Image;
